var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_253:6228)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.4853 15.5147C19.1783 14.2077 17.6226 13.2402 15.9253 12.6545C17.7432 11.4024 18.9375 9.30694 18.9375 6.9375C18.9375 3.11217 15.8253 0 12 0C8.17467 0 5.0625 3.11217 5.0625 6.9375C5.0625 9.30694 6.25683 11.4024 8.07478 12.6545C6.37744 13.2402 4.82175 14.2077 3.51473 15.5147C1.24823 17.7812 0 20.7947 0 24H1.875C1.875 18.417 6.41705 13.875 12 13.875C17.583 13.875 22.125 18.417 22.125 24H24C24 20.7947 22.7518 17.7812 20.4853 15.5147ZM12 12C9.20855 12 6.9375 9.729 6.9375 6.9375C6.9375 4.146 9.20855 1.875 12 1.875C14.7915 1.875 17.0625 4.146 17.0625 6.9375C17.0625 9.729 14.7915 12 12 12Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.6419 24.4688H7.31126C7.89143 26.4986 9.76048 27.9844 11.9766 27.9844C14.1926 27.9844 16.0617 26.4986 16.6419 24.4688ZM16.7985 22.5938H12.9375V18.3764C14.9846 18.7877 16.5657 20.4875 16.7985 22.5938ZM11.0625 22.5938V18.3672C8.99268 18.7618 7.38921 20.4715 7.15461 22.5938H11.0625ZM11.9766 29.8594C15.6915 29.8594 18.7031 26.8478 18.7031 23.1328C18.7031 19.4178 15.6915 16.4062 11.9766 16.4062C8.26158 16.4062 5.25 19.4178 5.25 23.1328C5.25 26.8478 8.26158 29.8594 11.9766 29.8594Z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_253:6228"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "24"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }